import { getType } from "@serenity-is/corelib";

// The Sisolco.Organisation dialogs the project lookups create records with (InplaceAdd on
// ProjectHeaderRow). They are not in the type registry on a KeyView page: the library registers each one
// only as a side effect of its standalone ESM module, which it otherwise loads only for a dashboard's
// openEntityDialog. Serenity asks Config.lazyTypeLoader for an unregistered dialog key and accepts a
// promise (DialogTypeRegistry.getOrLoad), so importing the module on demand is enough.
//
// Only these four keys are resolved. The registry also probes the key with "Dialog" appended and with
// each root namespace prefixed; those miss the map and fall through to the previous loader.
export const organisationDialogModules: Readonly<Record<string, string>> = {
    "Sisolco.Organisation.CompanyDialog": "/Sisolco.Organisation/esm/Modules/Organisation/Company/CompanyDialogModule.js",
    "Sisolco.Organisation.BusinessUnitDialog": "/Sisolco.Organisation/esm/Modules/Organisation/BusinessUnit/BusinessUnitDialogModule.js",
    "Sisolco.Organisation.ContactDialog": "/Sisolco.Organisation/esm/Modules/Organisation/Contact/ContactDialogModule.js",
    "Sisolco.Organisation.AddressDialog": "/Sisolco.Organisation/esm/Modules/Organisation/Address/AddressDialogModule.js",
};

// The URL is absolute and same-origin, so esbuild leaves it alone.
let importModule: (url: string) => Promise<unknown> = url => import(/* @vite-ignore */ url);

/** Replaces the module importer; for tests. */
export function setOrganisationModuleImporter(importer: (url: string) => Promise<unknown>): void {
    importModule = importer;
}

/**
 * Resolves one of the four Organisation dialog keys by importing its module and then reading the type it
 * registered. Returns undefined for any other key or kind, so the caller can fall through.
 */
export function loadOrganisationDialog(typeKey: string | undefined, kind: string | undefined): Promise<unknown> | undefined {
    if (kind !== "dialog" || !typeKey)
        return undefined;
    const url = organisationDialogModules[typeKey];
    if (!url)
        return undefined;
    return importModule(url).then(() => getType(typeKey) ?? null);
}
